import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=62ff5ed2&scoped=true&"
import script from "./Instructors.vue?vue&type=script&lang=js&"
export * from "./Instructors.vue?vue&type=script&lang=js&"
import style0 from "./Instructors.vue?vue&type=style&index=0&id=62ff5ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ff5ed2",
  null
  
)

export default component.exports